// frontend/src/services/profileService.js
import apiClient from '../api/apiClient';
import authService from './authService';

export const getUserProfile = async () => {
    const response = await apiClient.get('/profile/me/');
    const data = response?.data;
    if (!data) return {};
    // ساختارهای محتمل: data.data, data.user, data.results[0], خود data
    return data.data || data.user || (data.results?.[0]) || data;
};

export const updateUserProfile = async (profileData) => {
    const response = await apiClient.patch('/profile/me/', profileData);
    const data = response?.data;
    if (!data) return {};
    return data.data || data.user || (data.results?.[0]) || data;
};

export const getWatchedHistory = async (nextPageUrl = null) => {
    try {
        const url = nextPageUrl || '/profile/history/';
        const response = await apiClient.get(url);
        return response.data;
    } catch {
        return { results: [], next: null };
    }
};

export const getFavoriteProducts = async (nextPageUrl = null) => {
    const url = nextPageUrl || '/profile/favorites/';
    const response = await apiClient.get(url);
    return response.data;
};

export const toggleProductLike = async (productId) => {
    const response = await apiClient.post(`/products/${productId}/toggle-like/`);
    return response.data; 
};

export const updatePlaybackPosition = async (mediaId, positionSec) => {
    const response = await apiClient.post('/products/user/history/update/', {
        media_id: mediaId,
        position_sec: positionSec
    });
    return response.data;
};

export const getDailyMessage = async () => {
    const response = await apiClient.get('/profile/daily-message/');
    const data = response?.data;
    if (!data) return {};
    return data.data || data;
};

export const submitVolunteerApplication = async (applicationData) => {
    const response = await apiClient.post('/profile/volunteer-application/', applicationData);
    return response.data;
};

export const getReferralCode = async () => {
    const response = await apiClient.get('/profile/referral/code/');
    return response.data;
};

export const getReferredUsers = async (nextPageUrl = null) => {
    const url = nextPageUrl || '/profile/referral/referred-users/';
    const response = await apiClient.get(url);
    return response.data;
};

const profileService = {
    getUserProfile,
    updateUserProfile,
    getWatchedHistory,
    getFavoriteProducts,
    toggleProductLike,
    updatePlaybackPosition,
    getDailyMessage,
    submitVolunteerApplication,
    getReferralCode,
    getReferredUsers,
    auth: authService
};

export default profileService;